/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  SearchProUsersParams,
  SearchUsersResponse,
} from './platformapi.schemas';

import searchProUsersMutator from '../custom-axios-instance';

/**
 * Get a paginated list of professional users based on search criteria.
 * @summary Search Pro Users
 */
export const searchProUsers = (params?: SearchProUsersParams, signal?: AbortSignal) => {
  return searchProUsersMutator<SearchUsersResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/search/users/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchProUsersQueryKey = (params?: SearchProUsersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/search/users/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchProUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchProUsers>>,
  TError = HTTPValidationError,
>(
  params?: SearchProUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProUsers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchProUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchProUsers>>> = ({ signal }) =>
    searchProUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchProUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchProUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchProUsers>>>;
export type SearchProUsersQueryError = HTTPValidationError;

export function useSearchProUsers<
  TData = Awaited<ReturnType<typeof searchProUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | SearchProUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProUsers>>,
          TError,
          Awaited<ReturnType<typeof searchProUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProUsers<
  TData = Awaited<ReturnType<typeof searchProUsers>>,
  TError = HTTPValidationError,
>(
  params?: SearchProUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchProUsers>>,
          TError,
          Awaited<ReturnType<typeof searchProUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchProUsers<
  TData = Awaited<ReturnType<typeof searchProUsers>>,
  TError = HTTPValidationError,
>(
  params?: SearchProUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Pro Users
 */

export function useSearchProUsers<
  TData = Awaited<ReturnType<typeof searchProUsers>>,
  TError = HTTPValidationError,
>(
  params?: SearchProUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchProUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchProUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
